export default __webpack_public_path__ + "static/media/icon_lodging.72885052.svg";